<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="partyTypeId"
          :items="partyTypesBankRuptcyFileItems"
          item-text="name"
          item-value="id"
          class="radio-button-option-v1"
          @change="changePartyType"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="partner.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item}">
            <v-icon
              color="primary"
              @click="showModal(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="partnerModal"
      :title="`${locale.partners.partner}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <partner
        :form-model="formModel"
        :loading="loading"
      ></partner>
    </naj-modal>
  </div>
</template>

<script>
import Partner from './partner.vue';
import { createNamespacedHelpers } from 'vuex';
import { partyTypeEnum } from '../../../../helpers/enum';
const { mapActions, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { Partner },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      partner: { list: [] },
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.partners.thePartner,
        },
        {
          value: 'share',
          text: this.local.bankruptcy.requestDetails.partners.share,
        },
        {
          value: 'action',
          text: '',
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      formModel: {},
      partyTypeId: partyTypeEnum.person,
      loading: false,
    };
  },
  computed: { 
    ...mapLUTState(['partyTypesBankRuptcyFile']), 
    partyTypesBankRuptcyFileItems() {
      return this.partyTypesBankRuptcyFile.filter(x=>x.id != partyTypeEnum.government);
    },
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['getPartnersByRequestObjectKey', 'getPartner']),
    loadData() {
      this.loading = true;
      this.getPartnersByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        partyTypeId: this.partyTypeId,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.partner = { ...data };
          this.partner.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.loadData();
    },
    showModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getPartner(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.partnerModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
    },
    changePartyType() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
.options-list {
  display: flex;
}
::v-deep .radio-button-option-v1 {
  .v-input--radio-group {
    .radio-button-option {
      background: #fff;
      border-top: 0px solid #fff;
      border-bottom: 0px solid #fff;
      &:first-child {
        border-right: 0px solid #fff;
      }
      &:last-child {
        border-left: 0px solid #fff;
      }
    }
  }
}
</style>